var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-start" },
        [
          _vm.type == "BULK"
            ? _c(
                "b-col",
                { staticClass: "w-100", attrs: { md: "2" } },
                [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-5 justify-content-start ml-0" },
        [
          _c(
            "b-col",
            {
              staticClass: "mt-2 pl-0",
              attrs: { cols: "4", lg: "2", xl: "2" },
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter",
                  on: {
                    click: function ($event) {
                      _vm.displayFilter = !_vm.displayFilter
                    },
                  },
                },
                [
                  _vm.displayFilter
                    ? _c("i", { staticClass: "fa-light fa-minus" })
                    : _c("i", { staticClass: "fa-light fa-plus" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("filter.fltr")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-2", attrs: { cols: "4", lg: "2", xl: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter",
                  on: {
                    click: function ($event) {
                      return _vm.refreshInbox()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-rotate-right" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.rfrsh")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "min-w-100 justify-content-start align-items-center" },
        [
          _vm.displayFilter
            ? _c(
                "b-col",
                {
                  staticClass: "filter-item mb-5",
                  attrs: { sm: "6", lg: "3", cols: "12" },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "filter-item-title",
                      attrs: { for: "filter-iban" },
                    },
                    [_vm._v(_vm._s(_vm.$t("account_tb.name")))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "filter-item-content" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.Name,
                          expression: "Name",
                          modifiers: { trim: true },
                        },
                      ],
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.Name,
                      },
                      staticStyle: { width: "100%" },
                      attrs: {
                        id: "filter-iban",
                        type: "text",
                        placeholder: _vm.$t("account_tb.name"),
                      },
                      domProps: { value: _vm.Name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.Name = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.displayFilter
        ? _c(
            "b-row",
            { staticClass: "min-w-100 justify-content-end mb-5 mr-1" },
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex flex-row-reverse mt-3",
                  attrs: { lg: "3", cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.applyFilter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.srch")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-3",
                      attrs: { size: "sm", disabled: !_vm.hasInputFilter },
                      on: { click: _vm.clearFilterFields },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("filter.clr_fltr_field")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.AccountTBList.length > 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter_2 ml-3",
                  attrs: { disabled: "" },
                  on: {
                    click: function ($event) {
                      return _vm.extractCSV()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-upload fs-14px" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "fab-label" }, [
                    _vm._v(_vm._s(_vm.$t("common.extract_page"))),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activateSpinner
        ? _c("spinner")
        : _vm.AccountTBList.length > 0
        ? _c(
            "div",
            { staticStyle: { overflow: "auto" } },
            [
              _vm.AccountTBStat.length > 0
                ? _c("chart-pie-stat", { attrs: { stat: _vm.AccountTBStat } })
                : _c("div", { staticClass: "d-flex justify-content-center" }, [
                    _c("span", { staticClass: "noResult" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("account_tb.no_data")) +
                          "\n    "
                      ),
                    ]),
                  ]),
              _vm._v(" "),
              _c("b-table", {
                staticClass: "table table-striped mt-5",
                staticStyle: { "margin-bottom": "0" },
                attrs: {
                  hover: "",
                  fields: _vm.fields,
                  items: _vm.AccountTBList,
                  selectable: _vm.AccountTBList.length > 0,
                  "empty-text": _vm.$t("common.security.no_result"),
                },
                on: { "row-clicked": _vm.seeAccountTBDetails },
                scopedSlots: _vm._u([
                  {
                    key: "cell(IsRVM)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "text-ellipsis" }, [
                          data.item.IsRVM == 1
                            ? _c("i", {
                                staticClass: "fa-solid fa-check text-success",
                              })
                            : _c("i", {
                                staticClass: "fa-solid fa-xmark text-danger",
                              }),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(SessionTest)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "text-ellipsis" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getSessionTestStatus(
                                data.item.StartDate,
                                data.item.EndDate
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(Progress)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "text-ellipsis" }, [
                          _vm._v(
                            _vm._s(
                              data.item.TotalOk == ""
                                ? 0
                                : (
                                    (data.item.TotalOk / data.item.TotalTest) *
                                    100
                                  ).toFixed(2)
                            ) + " %"
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          )
        : _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c("span", { staticClass: "noResult" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("common.no_result")) + "\n    "
              ),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("cm-pagination", {
                attrs: {
                  maxResultsByPage: _vm.paginationObject.maxResults,
                  firstIndex: _vm.paginationObject.firstIndex,
                  nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                  refreshEvent: _vm.paginationObject.refresh,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }